import { useNavigate } from "react-router-dom";
import { ReactComponent as ProductoIcon } from "../../../../../assets/icons/productoIcon.svg";
import { ReactComponent as ProductoEditorialIcon } from "../../../../../assets/icons/productoEditorialIcon.svg";
import { ReactComponent as ProductoDistribucionIcon } from "../../../../../assets/icons/productoDistribucionIcon.svg";
import { ReactComponent as ProductoCorporativoIcon } from "../../../../../assets/icons/productoCorporativoIcon.svg";
import { ReactComponent as ProductoPlantelIcon } from "../../../../../assets/icons/productoPlantelIcon.svg";
import { ReactComponent as ViewIcon } from "../../../../../assets/icons/view.svg";
import { ReactComponent as DeleteIcon } from "../../../../../assets/icons/deleteIcon.svg";
import { ReactComponent as VariacionesIcon } from "../../../../../assets/icons/variacionesIcon.svg";
import { ReactComponent as EditarPrecioAsignacion } from "../../../../../assets/icons/editarPrecioAsignacion.svg";
import { ReactComponent as EditIcon } from "../../../../../assets/icons/Edit.svg";
import { useContext, useEffect, useMemo, useState } from "react";
import { UserContext } from "../../../../services/user";
import EliminarProductoModal from "./EliminarProductoModal";
import { formatCurrency } from "../../../../utils/productoUtils";
import { obtenerUserEstructuraInfo } from "../../../../utils/userUtils";
import EditarPrecioVentaModal from "./EditarPrecioVentaModal";
import { PaisesContext } from "../../../../../contexts/PaisesContext";
import { obtenerEstructuraYRelaciones } from "../../../../services/Api/Autorizacion";
import { convertirMoneda, convertirMonedaOrigen } from "../../../../utils/conversionMonedasUtils";

const IconColor = {
  "Casa editorial": ProductoEditorialIcon,
  Distribución: ProductoDistribucionIcon,
  Corporativo: ProductoCorporativoIcon,
  Plantel: ProductoPlantelIcon,
};

const ProductosRow = ({ productoInfo, obtenerProductos, tipoDeMoneda }) => {
  const { permissions, user, activeRole } = useContext(UserContext);
  const { obtenerPaises, paises, estructuras } = useContext(PaisesContext); 
  const navigate = useNavigate();
  const [isDeleteProductModalOpen, setIsDeleteProductModalOpen] = useState(false);
  const [isEditPriceProductModalOpen, setIsEditPriceProductModalOpen] = useState(false);
  const [conversionMonedas, setConversionMonedas] = useState({});

  const { _id, precioVenta, producto, origen, provieneDe, costo } = productoInfo;
  const { nombre, categoria, tipoProducto, estatus, configuracionProducto } = producto;

  const ganancia = useMemo(() => {
    let nuevaGanancia = precioVenta - convertirMoneda(costo, conversionMonedas);
    nuevaGanancia = nuevaGanancia.toFixed(2);
    return nuevaGanancia === "-0.00" ? "0.00" : nuevaGanancia;
  }, [precioVenta, costo, conversionMonedas]);

  const IconEstructura = useMemo(() => {
    if (activeRole === "") return ProductoIcon;

    if (provieneDe) {
      const iconoProductoLinea = provieneDe.editorial
        ? "Casa editorial"
        : provieneDe.distribucion
        ? "Distribución"
        : provieneDe.corporativo
        ? "Corporativo"
        : "Plantel";

      return IconColor[iconoProductoLinea];
    }

    const { tipoEstructura } = obtenerUserEstructuraInfo(user, activeRole);

    return IconColor[tipoEstructura];
  }, [activeRole]);

  const obtenerConversion = async () => {
    if (provieneDe) {
      const { editorial, distribucion, corporativo, dirFiscalPais } = estructuras;
      const paisOrigen = corporativo 
        ? corporativo.dirFiscalPais 
        : distribucion 
        ? distribucion.dirFiscalPais 
        : editorial.dirFiscalPais;
      const conversionBody = {
        paisOrigenId: paisOrigen,
        paisDestinoId: dirFiscalPais,
        paises: paises,
      };
      setConversionMonedas(conversionBody);   
    }
  };

  useEffect( () => {
      if(activeRole !== ""){
        obtenerConversion();
      }
    },[activeRole,  productoInfo]);
    
  return (
    <>
      <tr className="p-2 text-left bg-white">
        <td className="border-2 rounded-l-md border-r-0 text-left font-sans">
          <IconEstructura className="mx-auto" />
        </td>
        <td className="border-y-2 border-x-0 text-left font-sans">
          <p>{nombre}</p>
        </td>
        <td className="border-y-2 text-center font-sans">
          <p>{categoria === "otro" ? "Otros" : categoria}</p>
        </td>
        <td className="border-y-2 text-center font-sans">
          <p>{tipoProducto}</p>
        </td>
        <td className="border-y-2 font-sans">
          <p className="text-right mr-4">{formatCurrency(convertirMoneda(costo, conversionMonedas))}</p>
        </td>
        <td className="border-y-2 font-sans">
          <p className="text-right mr-4">{formatCurrency(precioVenta)}</p>
        </td>
        <td className="border-y-2 font-sans">
          <p
            className={`font-sans text-right mr-4 ${
              ganancia < 0 ? "text-red-600" : ganancia > 0 ? "text-green-600" : "text-inherit"
            }`}
          >
            {formatCurrency(ganancia)}
          </p>
        </td>
        <td className="border-y-2 font-sans text-center">
          <p>{origen === "Linea" ? "De línea" : origen}</p>
        </td>
        <td className="border-y-2 font-sans text-center">
          <p>{estatus ? "Disponible" : "Agotado"}</p>
        </td>
        <td className="border-2 rounded-r-md border-l-0 min-h-[52px]">
          <div className="flex justify-evenly items-center py-6 md:py-3 space-x-2 px-2">
            {provieneDe ? (
              <>
                <div className="invisible w-6"></div>
                <div className="invisible w-6"></div>
                <div className="invisible w-6"></div>
                <EditarPrecioAsignacion
                  title="Editar precio de venta"
                  className="cursor-pointer"
                  onClick={() => setIsEditPriceProductModalOpen(true)}
                />
              </>
            ) : (
              <>
                {permissions.productosPermits?.editar && (
                  <VariacionesIcon
                    title="Variaciones"
                    className={`${configuracionProducto !== "PRODUCTO_VARIABLE" && "invisible"} cursor-pointer`}
                    onClick={() => navigate(`/marketplace/gestionProductos/productos/${_id}/variaciones`)}
                  />
                )}
                {permissions.productosPermits?.editar && (
                  <EditIcon
                    title="Editar producto"
                    className="cursor-pointer"
                    onClick={() => navigate(`/marketplace/gestionProductos/productos/${_id}/editar`)}
                  />
                )}
                {permissions.productosPermits?.ver && (
                  <ViewIcon
                    title="Ver producto"
                    className="cursor-pointer"
                    onClick={() => navigate(`/marketplace/gestionProductos/productos/${_id}/ver`)}
                  />
                )}
                {permissions.productosPermits?.eliminar && (
                  <DeleteIcon
                    title="Eliminar producto"
                    className="cursor-pointer"
                    onClick={() => setIsDeleteProductModalOpen(true)}
                  />
                )}
              </>
            )}
          </div>
        </td>
      </tr>
      <EliminarProductoModal
        isOpen={isDeleteProductModalOpen}
        setIsOpen={setIsDeleteProductModalOpen}
        productoId={_id}
        nombre={nombre}
        obtenerProductos={obtenerProductos}
      />
      {
        isEditPriceProductModalOpen &&
        <EditarPrecioVentaModal
          isOpen={isEditPriceProductModalOpen}
          setIsOpen={setIsEditPriceProductModalOpen}
          productoId={_id}
          productoInfo={productoInfo}
          obtenerProductos={obtenerProductos}
          tipoDeMoneda={tipoDeMoneda}
          conversionMonedas={conversionMonedas}
        />
      }
    </>
  );
};

export default ProductosRow;
